import React, {useEffect} from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import PatientInfo from '../components/PatientInfo';
import OrderCard from '../components/OrderCard';
import {Theme} from '@material-ui/core/styles/createMuiTheme';
import {useAppState} from '../app/AppState';
import {getOrders} from '../api';
import {IOrder} from '../common/types';
import Loading from '../components/Loading';
import Header from '../components/Header';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    height: '100%',
    padding: 10,
    display: 'grid',
    gridGap: 10,
    gridTemplateColumns: '300px 1fr',
    gridTemplateRows: 'auto',
    alignContent: 'flex-start',
    justifyContent: 'flex-start',
    overflow: 'hidden',
    [theme.breakpoints.down(740)]: {
      gridTemplateColumns: '1fr',
      overflow: 'auto'
    }

  },
  patientInfoContainer: {
    height: '100%',
    padding: 1,
  },
  orderContainer: {
    padding: 1,
    display: 'grid',
    gridGap: 20,
    overflow: 'initial',
    paddingBottom: 10,
    alignContent: 'flex-start',
    [theme.breakpoints.up(740)]: {
      gridTemplateColumns: '1fr',
      overflow: 'auto',
    },
    [theme.breakpoints.up(1154)]: {
      gridTemplateColumns: '1fr 1fr',
    },
    [theme.breakpoints.up(1568)]: {
      gridTemplateColumns: '1fr 1fr 1fr',
    }
  }
}));


const LandingPage = () => {
  const cl = useStyles();
  const appState = useAppState();
  const [client] = appState.client;
  const [orders, setOrders] = appState.orders;
  const handleGerOrders = async () => {
    const result = await getOrders();
    if (result instanceof Error) return;

    setOrders(result);
  };

  useEffect(() => {
    handleGerOrders();
  }, []);

  if (client === null || orders === null) return <Loading />;
  return (
    <div className={cl.root}>

      <div className={cl.patientInfoContainer}>
        <PatientInfo />
      </div>
      <div className={cl.orderContainer}>
        {orders.map((order: IOrder) =>
          <OrderCard
            {...order}
            key={order.id}
          />)}
      </div>
    </div>
  );
};

export default LandingPage;
